<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                  <div class="card-header align-items-center border-bottom-dark px-0">
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        Arrived at Checkout
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <div class="dataTables_wrapper no-footer">

                      <div class="dataTables_length">
                        <label>Show
                          <select v-model="limit" v-on:change="fetchItems()">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                          entries
                        </label>
                      </div>

                      <div class="dataTables_filter">
                        <label>Search:
                          <input type="text" v-model="search" @keyup="fetchItems()" placeholder="" />
                        </label>
                        <button v-if="search !== ''" @click="clearSearch">clear</button>
                      </div>

                      <table class="display dataTable no-footer" style="width:100%">
                        <thead class="text-body">
                          <tr>
                            <th>#</th>
                            <th>Customer Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Arrived At</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="items.length === 0">
                            <td colspan="5" class="text-center">No records found.</td>
                          </tr>
                          <tr v-for="item in items" :key="item.id">
                            <td>{{ item.id }}</td>
                            <td>
                              <span v-if="item.customer">
                                {{ item.customer.first_name }} {{ item.customer.last_name }}
                              </span>
                              <span v-else class="text-muted">—</span>
                            </td>
                            <td>
                              <span v-if="item.customer">{{ item.customer.email }}</span>
                            </td>
                            <td>
                              <span v-if="item.customer">{{ item.customer.phone }}</span>
                            </td>
                            <td>{{ item.created_at }}</td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- Pagination -->
                      <div class="dataTables_paginate paging_simple_numbers">
                        <ul class="pagination">
                          <li class="paginate_button page-item" :class="{ disabled: !meta.prev_page_url }">
                            <a class="page-link" href="#" @click.prevent="fetchItems(meta.prev_page_url)">Previous</a>
                          </li>
                          <li class="paginate_button page-item active">
                            <a class="page-link" href="#">{{ meta.current_page }} / {{ meta.last_page }}</a>
                          </li>
                          <li class="paginate_button page-item" :class="{ disabled: !meta.next_page_url }">
                            <a class="page-link" href="#" @click.prevent="fetchItems(meta.next_page_url)">Next</a>
                          </li>
                        </ul>
                        <div class="mt-2 text-muted">Total: {{ meta.total }} records</div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      meta: {},
      limit: 25,
      search: '',
      token: {},
    };
  },
  methods: {
    fetchItems(page_url) {
      let url = page_url || '/api/admin/admin-arrived-checkouts';
      const separator = url.includes('?') ? '&' : '?';
      url += separator + 'limit=' + this.limit;
      if (this.search !== '') {
        url += '&search=' + encodeURIComponent(this.search);
      }
      axios.get(url, this.token).then((res) => {
        this.items = res.data.data;
        this.meta  = res.data.meta;
      });
    },
    clearSearch() {
      this.search = '';
      this.fetchItems();
    },
  },
  mounted() {
    const token = localStorage.getItem('token');
    this.token = { headers: { Authorization: `Bearer ${token}` } };
    this.fetchItems();
  },
};
</script>
